'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDanger$002dAlert$0024$0024anon$00248 from "./presto.-Danger-Alert$$anon$8.js";
import * as $j_presto$002etypes$0024$002dPlan$002dCode$0024 from "./presto.types$-Plan-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_DangerAlert$$anon$7() {
  this.aJs = null;
  this.aJq = null;
  this.aJr = false;
  this.aJo = null;
  this.aJp = false;
  this.aJt = false;
  this.aJu = false;
  this.aJs = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_DangerAlert$$anon$7 as $c_Lpresto_DangerAlert$$anon$7 };
$p = $c_Lpresto_DangerAlert$$anon$7.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DangerAlert$$anon$7;
/** @constructor */
function $h_Lpresto_DangerAlert$$anon$7() {
}
export { $h_Lpresto_DangerAlert$$anon$7 as $h_Lpresto_DangerAlert$$anon$7 };
$h_Lpresto_DangerAlert$$anon$7.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.aJs;
});
$p.t = (function() {
  if ((!this.aJr)) {
    this.aJq = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("features", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aJr = true;
  }
  return this.aJq;
});
$p.ag = (function() {
  if ((!this.aJp)) {
    this.aJo = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dPlan$002dCode$0024.$m_Lpresto_types$PlanCode$().cJc(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25(new $j_presto$002e$002dDanger$002dAlert$0024$0024anon$00248.$c_Lpresto_DangerAlert$$anon$8()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aJp = true;
  }
  return this.aJo;
});
$p.v = (function() {
  if ((!this.aJu)) {
    this.aJt = false;
    this.aJu = true;
  }
  return this.aJt;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_DangerAlert$$anon$7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DangerAlert$$anon$7, "presto.DangerAlert$$anon$7", ({
  Gu: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_DangerAlert$$anon$7 as $d_Lpresto_DangerAlert$$anon$7 };
//# sourceMappingURL=presto.-Danger-Alert$$anon$7.js.map
